import { render, staticRenderFns } from "./Invent.vue?vue&type=template&id=d13726e0&scoped=true&"
import script from "./Invent.vue?vue&type=script&lang=js&"
export * from "./Invent.vue?vue&type=script&lang=js&"
import style0 from "./Invent.vue?vue&type=style&index=0&id=d13726e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13726e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
